<template>
	<div class="flex gap-4">
		<div
			v-for="(image, index) in images"
			:key="imageId(image) + index"
			class="text-[0px]"
		>
			<button type="button" class="py-1" @click="setBigImageIndex(index)">
				<p
					class="w-4 h-[2px]"
					:class="bigImageIndex === index ? 'bg-secondary' : 'bg-gray-200'"
				>
					{{ index + 1 }} / {{ images.length }}
				</p>
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { ProductFile } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { CategoryFiles } from "@nwt/norce-pwa/dist/runtime/types/api/category/category";
import type { FilteredProductItemFiles } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";
import type { BigImageIndex } from "~/types/storyblok/imageGallery/imageGallery";

interface Props {
	images: ProductFile[] | CategoryFiles[] | FilteredProductItemFiles[];
	bigImageIndex: number;
	setBigImageIndex: BigImageIndex;
}

defineProps<Props>();

const imageId = (
	image: ProductFile | CategoryFiles | FilteredProductItemFiles
) => {
	return isCategoryFile(image) || isFilteredProductItemFiles(image)
		? image.ImageKey!
		: image.Key!;
};
</script>
